<template>
    <ChartLayout :showEmptyChart="showEmptyChart">
        <template #title><span v-html="$t('OrganizationReport.total_hours_watched')"></span></template>
        <LineChart :data="data" :categories="categories" v-show="!showEmptyChart" />
    </ChartLayout>
</template>

<script>
    import LineChart from 'components/user/charts/LineChart'
    import ChartLayout from 'components/user/organizationreport/charts/ChartLayout'
    import emptyChartHelper from 'components/user/organizationreport/charts/helpers/emptyChartHelper'

    export default {
        name: 'total-hours-watched-chart',
        components: { LineChart, ChartLayout },
        mixins: [emptyChartHelper],
        props: {
            graphData: {
                type: Array
            }
        },
        computed: {
            data () {
                let sum = 0
                return this.graphData.map(item => sum += (item.value / 60))
            },
            categories () {
                return this.graphData.map(item => item.label)
            }
        }
    }
</script>
